import {
    takeEvery,
    all,
    call,
    put
} from 'redux-saga/effects';
import { LOCATION_CHANGE, push } from 'connected-react-router';
import urlJoin from 'url-join';
import * as webJobsDetailsApi from '../../../api/webJobsApi';
import * as actions from './actions';
import { getVirtualDirectory } from '../../../common/helpermethods/HelperMethods';

const webJobsDataLoadPath = urlJoin(getVirtualDirectory(), '/admin/webjobs');
const webJobsDetailsPath = urlJoin(getVirtualDirectory(), '/admin/webjobs/details');

export function* handleLocationChanged(api, action) {
    try {
        yield put(actions.setLoading(true));
        const split = action.payload.location.search.split('=');
        const id = JSON.parse(decodeURIComponent(split[1]));
        const detailsRows = yield call(api.fetchDataDetails, id);
        yield put(actions.setRows(detailsRows));
    } catch (error) {
        yield put(actions.fetchDataLoadsFailed(error.message));
    } finally {
        yield put(actions.setLoading(false));
    }
}

export function* returnToDataLoad() {
    yield put(push(webJobsDataLoadPath));
}

export default function* rootSaga() {
    yield all([
        takeEvery(
            action => action.type === LOCATION_CHANGE
            && action.payload.location.pathname.toLowerCase() === webJobsDetailsPath.toLowerCase(),
            handleLocationChanged,
            webJobsDetailsApi
        ),
        takeEvery(actions.RETURN_TO_DATA_LOAD, returnToDataLoad)
    ]);
}
